import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import Layout, { PageHeader } from "@/components/Layout";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";

export default function Users() {
  const { user } = useAuth();
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const isAdmin = ["Super Admin", "Firm Admin"].includes(user?.role);

  const load = () => api.get("/users").then((r) => setUsers(r.data));
  useEffect(() => {
    load();
    api.get("/meta").then((r) => setRoles(r.data.roles));
  }, []);

  const changeRole = async (uid, role) => {
    try {
      await api.patch(`/users/${uid}/role`, { role });
      toast.success("Peran diperbarui");
      load();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Gagal");
    }
  };

  if (user && !isAdmin) return <Navigate to="/" replace />;

  return (
    <Layout>
      <PageHeader title="Pengguna & Peran" subtitle="Manajemen pengguna dan segregasi peran" breadcrumb="Audit OS · Admin" />
      <div className="p-6">
        <div className="bg-white border border-border rounded-sm overflow-x-auto">
          <table className="w-full audit-table">
            <thead><tr><th>Nama</th><th>Email</th><th>Metode</th><th className="w-64">Peran</th></tr></thead>
            <tbody>
              {users.map((u) => (
                <tr key={u.id} data-testid={`user-row-${u.id}`}>
                  <td className="font-medium">{u.name}</td>
                  <td className="font-mono text-xs">{u.email}</td>
                  <td>{u.auth_provider === "google" ? "Google" : "Email"}</td>
                  <td>
                    <Select value={u.role} onValueChange={(v) => changeRole(u.id, v)}>
                      <SelectTrigger className="h-8" data-testid={`role-select-${u.id}`}><SelectValue /></SelectTrigger>
                      <SelectContent>{roles.map((r) => <SelectItem key={r} value={r}>{r}</SelectItem>)}</SelectContent>
                    </Select>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </Layout>
  );
}
